import { Injectable } from '@angular/core';
import { SuiteModel } from '../Models/suite-model';
import { SuiteMock } from '../DataStore/Mock/suite-mock';
import { RestService } from './rest.service';
import { Observable } from 'rxjs';
import { TopNavComponentComponent } from '../AppBaseComponents/top-nav-component/top-nav-component.component';

@Injectable({
  providedIn: 'root'
})
export class SuiteService {
  public suites: SuiteModel[] = [];
  suiteMock: SuiteMock;
  constructor(public rest: RestService) { }

  public findByObjectId(id: string): SuiteModel {
    return SuiteMock.findByObjectId(id);
  }

  public findById(id: number): SuiteModel {
    return SuiteMock.findById(id);
  }

  public getItems(): Observable<SuiteModel> {
    let projectId = localStorage.getItem("projectId");
    if (TopNavComponentComponent.currentPage.name.toUpperCase() != 'CANVAS') {
      return this.rest.get('projectSuites', projectId)
    }
    else {
      return this.rest.get('projectSuitesdb2', localStorage.getItem('projectIdDb2'))
    }
  }

  public getItemsdb2(): Observable<SuiteModel> {
    return this.rest.get('projectSuitesdb2', localStorage.getItem('projectIdDb2'))
  }

  public addNew(name: string, mydata: any) {
    let model = new SuiteModel();
    model.name = name;
    let projectId = localStorage.getItem("projectId");
    var data: any = {
      project: { _id: projectId },
      suite: model
    };
    if (mydata && mydata.selectedData) {
      data.projectEpic = {
        epic_id: mydata.selectedData.epic_id,
        epic_name: mydata.selectedData.epic_name,
        epicStatus: mydata.selectedData.epicStatus,
        project_management_type: mydata.selectedData.project_management_type,
        _type: mydata.selectedData._type,
        project_id: projectId
      };
    }
    if (TopNavComponentComponent.currentPage.name.toUpperCase() != 'CANVAS') {
      return this.rest.put('addsuite', data);
    }
    else {
      data.project._id = localStorage.getItem('projectIdDb2');
      return this.rest.put('addsuitedb2', data);
    }
  }

  public edit(model, mydata?: any) {
    console.log('Suite Service Edit - model:', model);
    console.log('Suite Service Edit - mydata:', mydata);
    
    let projectId = localStorage.getItem("projectId");
    if (model.models) {
      model.models = model.models.map(m => { return m = m.$oid });
    }
    model.created_time = model.created_time.$numberLong;
    model.updated_time = model.updated_time.$numberLong;
    var data: any = {
      project: { _id: projectId },
      suite: model
    };
    
    // Handle projectEpicMappingModel for edit suite
    if (mydata && mydata.projectEpicMappingModel) {
      console.log('Adding projectEpicMappingModel to data:', mydata.projectEpicMappingModel);
      data.projectEpic = mydata.projectEpicMappingModel;
      data.changed = true;
    }
    // Fallback to old format for backward compatibility
    else if (data && data.selectedData) {
      console.log('Using selectedData fallback:', data.selectedData);
      data.projectEpic = {
        epic_id: data.selectedData.epic_id,
        epic_name: data.selectedData.epic_name,
        epic_key: data.selectedData.epic_key,
        epicStatus: data.selectedData.epicStatus,
        project_id: data.selectedData.project_id,
        _type: data.selectedData._type,
        project_management_type: data.selectedData.project_management_type,
      };
      data.changed = data.selectedData.changed;
    }
    
    console.log('Final data being sent to API:', data);
    
    if (TopNavComponentComponent.currentPage.name.toUpperCase() != 'CANVAS') {
      return this.rest.post('updatesuite', data);
    }
    else {
      data.project._id = localStorage.getItem('projectIdDb2');
      return this.rest.post('updatesuitedb2', data);
    }
  }

  public deleteModel(model) {
    let projectId = localStorage.getItem("projectId");
    if (model.models) {
      model.models = model.models.map(m => { return m = m.$oid });
    }
    model.created_time = model.created_time.$numberLong;
    model.updated_time = model.updated_time.$numberLong;
    let data = {
      project: { _id: projectId },
      suite: model
    };
    if (TopNavComponentComponent.currentPage.name.toUpperCase() != 'CANVAS') {

      return this.rest.post("deletesuite", data);
    }
    else {
      data.project._id = localStorage.getItem('projectIdDb2');
      return this.rest.post('deletesuitedb2', data);
    }
  }

  public saveAsModel(model) {
    let projectId = localStorage.getItem("projectId");
    if (model.dbName == 'db2') {
      projectId = localStorage.getItem("projectIdDb2");
    }
    model.created_time = model.created_time.$numberLong;
    model.updated_time = model.updated_time.$numberLong;
    if (model.models == null) {
      model['models'] = [];
    }
    else {
      const modelIds = model.models.map(model => model.$oid);
      model['models'] = modelIds;
    }
    let data = {
      project: { _id: projectId },
      suite: model
    };
    return this.rest.put('copysuite', data);
  }

  getJiraEpicList(pageSize: number = 10, nextPageToken: string = '') {
    let projectId = localStorage.getItem("projectId");
    let payload = {
      "projectId": projectId,
      "project_management_type": "jira",
      "maxResult": pageSize.toString(),
      "nextPageToken": nextPageToken
    }
    return this.rest.post('getProjectEpicForJira', payload, null)
  }

  getJiraIssueList() {
    return this.rest.get('getJiraIssueList', null, null)
  }
}
